import ReduxHelper from 'lib/ReduxHelper';
import {
  InsuranceReportDataGroup,
  MerchantReportDataGroup,
  AdminReportDataGroup,
} from 'vdlib';

export const REPORTS_ACTION_TYPES = {
  REPORTS_FETCH_AUCTION_DATA: 'REPORTS_FETCH_AUCTION_DATA',
  REPORTS_FETCH_AUCTION_DATA_SUCCESS: 'REPORTS_FETCH_AUCTION_DATA_SUCCESS',
  REPORTS_FETCH_AUCTION_DATA_FAIL: 'REPORTS_FETCH_AUCTION_DATA_FAIL',
  REPORTS_CLEAR_DATA: 'REPORTS_CLEAR_DATA',

  REPORTS_FETCH_INSURANCE_GENERAL_DATA: 'REPORTS_FETCH_INSURANCE_GENERAL_DATA',
  REPORTS_FETCH_INSURANCE_GENERAL_DATA_SUCCESS:
    'REPORTS_FETCH_INSURANCE_GENERAL_DATA_SUCCESS',
  REPORTS_FETCH_INSURANCE_GENERAL_DATA_FAIL:
    'REPORTS_FETCH_INSURANCE_GENERAL_DATA_FAIL',

  REPORTS_FETCH_INSURANCE_FOLDER_DATA: 'REPORTS_FETCH_INSURANCE_FOLDER_DATA',
  REPORTS_FETCH_INSURANCE_FOLDER_DATA_SUCCESS:
    'REPORTS_FETCH_INSURANCE_FOLDER_DATA_SUCCESS',
  REPORTS_FETCH_INSURANCE_FOLDER_DATA_FAIL:
    'REPORTS_FETCH_INSURANCE_FOLDER_DATA_FAIL',

  REPORTS_FETCH_MERCHANT_GENERAL_DATA: 'REPORTS_FETCH_MERCHANT_GENERAL_DATA',
  REPORTS_FETCH_MERCHANT_GENERAL_DATA_SUCCESS:
    'REPORTS_FETCH_MERCHANT_GENERAL_DATA_SUCCESS',
  REPORTS_FETCH_MERCHANT_GENERAL_DATA_FAIL:
    'REPORTS_FETCH_MERCHANT_GENERAL_DATA_FAIL',

  REPORTS_FETCH_ADMIN_GENERAL_DATA: 'REPORTS_FETCH_ADMIN_GENERAL_DATA',
  REPORTS_FETCH_ADMIN_GENERAL_DATA_SUCCESS:
    'REPORTS_FETCH_ADMIN_GENERAL_DATA_SUCCESS',
  REPORTS_FETCH_ADMIN_GENERAL_DATA_FAIL:
    'REPORTS_FETCH_ADMIN_GENERAL_DATA_FAIL',

  REPORTS_FETCH_ADMIN_FOLDER_DATA: 'REPORTS_FETCH_ADMIN_FOLDER_DATA',
  REPORTS_FETCH_ADMIN_FOLDER_DATA_SUCCESS:
    'REPORTS_FETCH_ADMIN_FOLDER_DATA_SUCCESS',
  REPORTS_FETCH_ADMIN_FOLDER_DATA_FAIL: 'REPORTS_FETCH_ADMIN_FOLDER_DATA_FAIL',
};

export const fetchAuctionsReportData = opts =>
  ReduxHelper.createAction(
    REPORTS_ACTION_TYPES.REPORTS_FETCH_AUCTION_DATA,
    opts,
  );

export const fetchInsuranceReportGeneralData = opts =>
  ReduxHelper.createAction(
    REPORTS_ACTION_TYPES.REPORTS_FETCH_INSURANCE_GENERAL_DATA,
    Object.assign(
      opts,
      { dataGroup: InsuranceReportDataGroup.General },
      { role: 'insurance' },
    ),
  );

export const fetchInsuranceReportFolderData = opts =>
  ReduxHelper.createAction(
    REPORTS_ACTION_TYPES.REPORTS_FETCH_INSURANCE_FOLDER_DATA,
    Object.assign(
      opts,
      { dataGroup: InsuranceReportDataGroup.Folders },
      { role: 'insurance' },
    ),
  );

export const fetchMerchantReportFolderData = opts =>
  ReduxHelper.createAction(
    REPORTS_ACTION_TYPES.REPORTS_FETCH_MERCHANT_GENERAL_DATA,
    Object.assign(
      opts,
      { dataGroup: MerchantReportDataGroup.General },
      { role: 'merchant' },
    ),
  );

export const fetchAdminReportGeneralData = opts =>
  ReduxHelper.createAction(
    REPORTS_ACTION_TYPES.REPORTS_FETCH_ADMIN_GENERAL_DATA,
    Object.assign(
      opts,
      { dataGroup: AdminReportDataGroup.General },
      { role: 'admin' },
    ),
  );

export const fetchAdminReportFolderData = opts =>
  ReduxHelper.createAction(
    REPORTS_ACTION_TYPES.REPORTS_FETCH_ADMIN_FOLDER_DATA,
    Object.assign(
      opts,
      { dataGroup: AdminReportDataGroup.Folders },
      { role: 'admin' },
    ),
  );
